import type { GameplayEventStreet } from '../../../Core/State/IJoinedRoomState';

export const WINNER_INDICATOR_DISPLAY_MS = 3500;
export const HAND_PRESENTATION_FADE_OUT_MS = 180;

// Keep these in sync with CardAnimations.css community-card move/flip durations.
export const COMMUNITY_CARD_TIMING = {
    moveDurationMs: 300,
    flipDurationMs: 300,
    revealCadenceMs: 400
} as const;

export const COMMUNITY_CARD_ANIMATION_TOTAL_MS =
    COMMUNITY_CARD_TIMING.moveDurationMs + COMMUNITY_CARD_TIMING.flipDurationMs;

export const COMMUNITY_CARD_PLACEMENT_AUDIO_CHANNEL = 'community-card-placement';

const TEXAS_PLAYER_CARD_STATES = new Set([
    'dealing',
    'preFlop',
    'flop',
    'turn',
    'river',
    'showdown',
    'showdownFold'
]);

const AOF_PLAYER_CARD_STATES = new Set([
    'dealing',
    'turn',
    'showdown',
    'showdownFold',
    'returnSidePots',
    'gameEnded'
]);

interface DetachedGameplayWindow {
    closed: boolean;
    document: Document;
}

export const getCommunityCardIndexesForStreet = (street: GameplayEventStreet | undefined): number[] => {
    switch (street) {
        case 'flop':
            return [0, 1, 2];
        case 'turn':
            return [3];
        case 'river':
            return [4];
        default:
            return [];
    }
};

export const shouldShowPlayerCardsForRoomState = (
    roomType: string | undefined,
    stateName: string | null | undefined,
    playerCardsVisible: boolean
): boolean => {
    if (!playerCardsVisible || !stateName) return false;

    if (roomType === 'texas') {
        return TEXAS_PLAYER_CARD_STATES.has(stateName);
    }

    if (roomType === 'aof') {
        return AOF_PLAYER_CARD_STATES.has(stateName);
    }

    return false;
};

export const isGameplayAudioPlaybackAllowed = (
    detachedWindow: DetachedGameplayWindow | null | undefined,
    isSingleRoomView: boolean
): boolean => {
    if (detachedWindow && !detachedWindow.closed) {
        return detachedWindow.document.hasFocus();
    }

    return isSingleRoomView && document.hasFocus();
};
